export const BundleTypeList = [
    { code: 'HERO', label: 'Hero' },
    { code: 'EVERGREEN', label: 'Evergreen' },
    { code: 'GROUP', label: 'Group' },
    { code: 'GENERAL', label: 'General' }
]

export const BundleStatusList = [
    { code: 'INPROGRESS', label: 'In Progress' },
    { code: 'ACTIVE', label: 'Active' },
    { code: 'ARCHIVED', label: 'Archived' },
]

export const SubscriptionTierList = [
    { code: 'FREE', label: 'Free Tier', defaultValue: true },
    { code: 'STANDARD', label: 'Standard Tier', defaultValue: true },
    { code: 'PREMIUM', label: 'Premium Tier', defaultValue: true }
]

export const PlaceholderImageUrl = 'https://static.amazingco.me/singularity/auth/AWT-Default.jpg';